import { APP_BUILD_TIME, APP_VERSION } from 'virtual:app-build-info';

/**
 * 生产环境：控制台打印版本信息；轮询 /version.json 与当前构建不一致时自动刷新（发版兜底）。
 */
const CHECK_INTERVAL_MS = 180_000;

function getVersionUrl(): string {
  const base = import.meta.env.BASE_URL || '/';
  const normalized =
    base.endsWith('/') && base.length > 1 ? base.slice(0, -1) : base;
  const path =
    normalized === '' || normalized === '/'
      ? '/version.json'
      : `${normalized}/version.json`;
  return new URL(path, window.location.origin).pathname;
}

export function setupVersionGuard(): void {
  if (!import.meta.env.PROD) {
    return;
  }

  const localVersion = APP_VERSION || import.meta.env.VITE_APP_VERSION;
  const localBuildTime = APP_BUILD_TIME || import.meta.env.VITE_APP_BUILD_TIME;

  console.info(
    `[${import.meta.env.VITE_APP_TITLE ?? 'App'}] 版本: ${localVersion} | 打包时间: ${localBuildTime}`,
  );

  let checking = false;

  async function checkRemote(): Promise<void> {
    if (checking) {
      return;
    }
    checking = true;
    try {
      const url = `${getVersionUrl()}?t=${Date.now()}`;
      const res = await fetch(url, { cache: 'no-store' });
      if (!res.ok) {
        return;
      }
      const data = (await res.json()) as {
        buildTime?: string;
        version?: string;
      };
      const remoteVersion = data.version;
      const remoteBuildTime = data.buildTime;
      if (
        remoteVersion &&
        remoteBuildTime &&
        (remoteVersion !== localVersion || remoteBuildTime !== localBuildTime)
      ) {
        window.location.reload();
      }
    } catch {
      // 忽略网络错误，避免影响使用
    } finally {
      checking = false;
    }
  }

  setInterval(checkRemote, CHECK_INTERVAL_MS);
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') {
      void checkRemote();
    }
  });
}
